import styled, { css } from 'styled-components'
import TextareaAutosize from 'react-textarea-autosize'
import { Comment } from 'semantic-ui-react'
import Color from 'color'

interface VisibilityWrapperProps {
  public: boolean
}

export const Metadata = styled(Comment.Metadata)`
  &&&&& {
    margin-left: 0;
    padding-top: 3px;
    color: #4d6c78;

    span {
      margin-left: 0.25em;
      font-style: italic;
    }
  }
`
export const CommentContainer = styled(Comment)`
  &&&& {
    padding: 0;
    margin: 0;

    .actions {
      margin-top: 1em;
    }
  }
`

export const CommentAnimation = styled.div`
  margin-bottom: 1em;
`

export const CommentBody = styled(Comment.Text)`
  white-space: pre-wrap;
  margin: 0 !important;
`

export const TextArea = styled(TextareaAutosize)`
  ${({ theme }) => css`
    border: 0;
    outline: 0;
    background-color: #fff;
    width: 100%;
    resize: none;
    padding: 0;
    color: ${theme.colors.abyss};
    font-size: 14px;
    font-weight: 300;
    line-height: 23px;
  `}
`

export const FluidCommentGroup = styled(Comment.Group)`
  &&& {
    max-width: 100%;
  }
`

export const VisibilityWrapper = styled.div<VisibilityWrapperProps>`
  background-color: ${props =>
    Color(props.public ? props.theme.colors.green : props.theme.colors.yellow)
      .lighten(0.4)
      .string()};
  border-radius: 7px;
  margin-left: 5px;
  padding: 3px 6px;
  cursor: pointer;
  font-size: 0.9em;
  color: ${props =>
    Color(props.public ? props.theme.colors.green : props.theme.colors.yellow)
      .darken(0.4)
      .string()};

  &&& {
    .icon {
      color: ${props =>
        Color(
          props.public ? props.theme.colors.green : props.theme.colors.yellow,
        )
          .darken(0.4)
          .string()} !important;
    }
  }
`
